import {NgModule} from '@angular/core';

import {MdcLineRipple} from './line-ripple';

@NgModule({
  exports: [MdcLineRipple],
  declarations: [MdcLineRipple]
})
export class MdcLineRippleModule { }
